<template>
    <header class="app-header">
        <div class="container">
            <div class="header-content">
                <div class="logo-section">
                    <router-link to="/e-commerce-web" class="logo">
                        <!-- <div class="logo-icon">🛒</div> -->
                          <v-img v-if="websiteSettings.SYSTEM_IMAGE" :src="getImgUrl(websiteSettings.SYSTEM_IMAGE)"  max-width="55" />
                        <h1 class="store-name">{{ websiteSettings.SYSTEM_NAME }}</h1>
                    </router-link>
                </div>
                <SearchBar class="desktop-search" />
                <div class="header-actions">
                    <v-btn icon class="cart-btn" @click="toggleCart" aria-label="Shopping Cart">
                        <v-icon color="black">🛒</v-icon>
                        <span v-if="cartItemCount > 0" class="cart-badge">
                            {{ cartItemCount }}
                        </span>
                    </v-btn>
                    <v-btn icon class="cart-btn" @click="gotoOrders" aria-label="Shopping Cart">
                        <v-icon color="black">📰</v-icon>
                    </v-btn>
                </div>
            </div>
            <SearchBar class="mobile-search" />
        </div>
    </header>
</template>
<script>
import SearchBar from './SearchBar.vue'
import { mapGetters, mapState } from 'vuex'
export default {
    name: 'AppHeader',
    components: { SearchBar },
    data() {
        return {
            storeName: 'TechStore'
        }
    },
    computed: {
        ...mapGetters({
            cartItemCount: 'cart/cartItemCount',
        }),
        ...mapState({
            websiteSettings: state => state.websiteSettings
        })
    },
    methods: {
        toggleCart() {
            this.$store.dispatch('cart/toggleCart');
        },
        getImgUrl(item) {
            let domain = `${this.$store.state.serverDomain}/storage/`;
            return domain + item;
        },
        gotoOrders(){
            if(localStorage.getItem("access_token"))
                this.$router.push('/e-commerce-web/myOrder');
            else this.$store.commit('SET_OTP_MODAL', true, { root: true });
        }
    }
}
</script>

<style scoped>
.app-header {
    background: var(--bg-color--background) !important;
    color: var(--bg-color--font) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
}

.logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.logo-icon {
    font-size: 28px;
    margin-right: 10px;
}

.store-name {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.desktop-search {
    flex: 1;
    max-width: 500px;
    margin: 0 30px;
}

.mobile-search {
    display: none;
    margin-bottom: 15px;
}

.cart-btn {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    padding: 5px;
}

.cart-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ff4757;
    color: white;
    font-size: 12px;
    font-weight: bold;
    min-width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
}

@media (max-width: 768px) {
    .desktop-search {
        display: none;
    }

    .mobile-search {
        display: block;
    }

    .store-name {
        font-size: 20px;
    }
}
</style>